














































































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Prop, PropSync, Watch} from "vue-property-decorator";
import {LadingError} from "@/interfaces/entity/ladingerror";
import {LadingErrorCustomerStore} from "../store";
import {LadingStatus} from "@/enums/status";
import {LadingPaymentType} from "@/enums/type";
import {FormModel} from "ant-design-vue";
import RotateImage from "@/shared/components/RotateImage/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import AutocompletePhoneCustomer from "@/shared/components/AutocompletePhoneCustomer/index.vue";
import ATextareaCustom from "@/shared/components/TextAreaAntCustom/index.vue";

const form = {
    customerResponse: ""
};
@Component({
    name: "LadingErrorCustomerDetail",
    components: {ATextareaCustom, AutocompletePhoneCustomer, CustomerSelector, AInputCustom, RotateImage}
})
export default class extends mixins(CommonMixin) {
    @Prop() id!: number;
    @PropSync('visibleDetail') visibleDetailSync!: boolean;
    ladingError: LadingError = null as any;
    LadingStatus = LadingStatus;
    LadingPaymentType = LadingPaymentType;
    form = { ...form };
    rules = {
        customerResponse: [{ required: true, message: "Nhập hướng dẫn xử lý", trigger: 'change' }]
    }

    @Watch('id', { immediate: true })
    onChangeId(val: any) {
        console.log(val);
        if (this.id) {
            this.singleLadingError(val);
        }
    }

    async singleLadingError(id: number) {
        try {
            this.ladingError = await LadingErrorCustomerStore.singleLadingErrorCustomer(id);
        } catch (e) {
            this.$message.error(e?.respose?.data?.message || "Đã xảy ra lỗi");
        }
    }

    createCustomerResponse() {
        (this.$refs.customerResponseForm as FormModel).validate( async (valid) => {
            if (!valid) return;
            try {
                await LadingErrorCustomerStore.responseLadingErrorCustomer({ ...this.form, id: this.id });
                this.$message.success("Hướng dẫn xử lý thành công");
                this.visibleDetailSync = false;
            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
            }
        })
    }
}
